import { render, staticRenderFns } from "./BusinessEntitiesOverview.vue?vue&type=template&id=56a68746&scoped=true&"
import script from "./BusinessEntitiesOverview.vue?vue&type=script&lang=js&"
export * from "./BusinessEntitiesOverview.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEntitiesOverview.vue?vue&type=style&index=0&id=56a68746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a68746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a68746')) {
      api.createRecord('56a68746', component.options)
    } else {
      api.reload('56a68746', component.options)
    }
    module.hot.accept("./BusinessEntitiesOverview.vue?vue&type=template&id=56a68746&scoped=true&", function () {
      api.rerender('56a68746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BusinessEntities/BusinessEntitiesOverview.vue"
export default component.exports